/* Copyright (c) 2022-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { Button, theme } from "@nordcloud/gnui";
import { generateDataUrl } from "~/views/estate/EstateDetailsPage/utils";

type DownloadJsonFileButtonProps = {
  buttonName: string;
  data?: Record<string, unknown>;
  fileName?: string;
};

export function DownloadJsonFileButton(props: DownloadJsonFileButtonProps) {
  const nameWithoutMostSpecialCharacters = (name: string) =>
    `${name.replaceAll(/[^\w-]/g, "")}.json`;

  const fileName = props.fileName
    ? nameWithoutMostSpecialCharacters(props.fileName)
    : `default.json`;

  return (
    <Button
      // @ts-expect-error Button should be enhanced with download attribute;
      download={fileName}
      severity="low"
      css={{ marginRight: theme.spacing.spacing01 }}
      linkTo={generateDataUrl(props.data)}
      data-testid="btn-download"
    >
      {props.buttonName}
    </Button>
  );
}
